import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useGetDirectPaymentFormItByID = () => {
  const [loadingGetSolicitudGastosContingenciaProfesionalById, setLoadingCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [successGetSolicitudGastosContingenciaProfesionalById, setSuccessCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [errorGetSolicitudGastosContingenciaProfesionalById, setErrorCreateSolicitudGastosContingenciaProfesional] = useState(null);
  const [dataGetSolicitudGastosContingenciaProfesionalById, setDataSolicitudGastosContingenciaProfesional] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //GET
  const getSolicitudGastosContingenciaProfesionalById = async (userId, prestacionId, id, _cb?: (data: any) => void) => {
    setLoadingCreateSolicitudGastosContingenciaProfesional(true);
    setSuccessCreateSolicitudGastosContingenciaProfesional(false);
    setErrorCreateSolicitudGastosContingenciaProfesional(null);

    try {
      const res = await apiRecord.getSolicitudGastosContingenciaProfesionalItByID(userId, prestacionId, id);
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setSuccessCreateSolicitudGastosContingenciaProfesional(true);
      setDataSolicitudGastosContingenciaProfesional(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }
      return res.data; // Retorna los datos correctamente
    } catch (err) {
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setErrorCreateSolicitudGastosContingenciaProfesional(err);
      console.error("Error en getSolicitudGastosContingenciaProfesionalById:", err);
      throw err;
    }
  };

  //UPDATE




  return {
    getSolicitudGastosContingenciaProfesionalById,
    loadingGetSolicitudGastosContingenciaProfesionalById,
    successGetSolicitudGastosContingenciaProfesionalById,
    errorGetSolicitudGastosContingenciaProfesionalById,
    dataGetSolicitudGastosContingenciaProfesionalById
  }

}

export default useGetDirectPaymentFormItByID;